export default "__VITE_ASSET__05056dbd__"